import React, {useState} from 'react'
import { Chart } from "react-google-charts";
import Spinner from 'react-bootstrap/Spinner';
import Container from 'react-bootstrap/Container';
import Label from 'react-bootstrap/FormLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import ReMultiSelect from 'react-select';
import ReMultiSelectAnimated from 'react-select/animated';
import alasql from 'alasql';
import KID_Style_Cap from "../images/90_KID_Style_Cap.jpg";
import AIRPLANE_MODE_006 from "../images/AIRPLANE_MODE_006.jpg";
import Harry_Potter_The_Houses_Men_Oversized_Hoodies from "../images/Harry_Potter_The_Houses_Men_Oversized_Hoodies.jpg";
import Club_Tennis_Short from "../images/Club_Tennis_Short.jpg";


function ProductCRO({ViewedPage, shop_domain, app_url}) {
    ViewedPage(9);

    const [loading, setLoading] = useState(false);
    const [price_range, setPriceRange] = useState([["all"]]);
    const [selected_product_type, setProductType] = useState([]);
    const [sselected_analyse_sku, setAnalyseProductType] = useState("");
    const [filtered_hetmap_data, setHeatmapData] = useState({});
    const [scatter_overview_data, setScatterOverviewData] = useState(get_scatter_overview_data(overview_data, price_range, selected_product_type));
    
    // const [selected_date_range_value, setDateRange] = useState([]);
    // const understand_data = [
        //     {"session":465, "add_to_cart":396, "checkout":169, "purchase":150}
        // ];
    // const funnel_data = [
    //     {"name":"Sessions", "value":399, "fill":"#28ccff"},
    //     {"name":"Add To Cart", "value":249, "fill":"#28ccff"},
    //     {"name":"Checkouts", "value":179, "fill":"#28ccff"},
    //     {"name":"Purchases", "value":150, "fill":"#28ccff"}
    // ];
    // const product_wise_funnel_data = [
    //     ["Product", "Sessions", "Add To Cart", "Checkouts", "Purchases"],
    //     ["90’S KID Style Cap",10, 3, 3, 3],
    //     ["AIRPLANE MODE // 006",15, 10, 6, 5],
    //     ["BAD ACID BLACK OVERSIZED T-SHIRT",50, 30, 26, 17],
    //     ["BLUE OVERSIZED T-SHIRT",70, 34, 30, 30],
    //     ["CLUB TENNIS SHORTS",15, 10, 7, 5],
    //     ["CRUISER // 004",6, 3, 3, 3],
    //     ["DREAMER Cap",10, 5, 4, 4],
    //     ["DRIP AUTHORITY Cap",14, 5, 4, 3],
    //     ["Flight MVP Men's Woven Trousers",75, 60, 42, 35],
    //     ["GENIE BLACK DENIM JACKET",69, 53, 30, 25],
    //     ["Harry Potter: The Houses Men Oversized Hoodies",65, 46, 29, 20],
    // ];

    return (
        <div className='main-container'>
            {!shop_domain?
                <div className='go_to_shopify_admin_div'>
                    <h5 style={{display:'inline-block'}}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
                :
                <>
                    { !loading ?
                        <>
                            <div className='main-title mt-4'>
                                <h2>Product Optimization</h2>
                            </div>


                            <p className='metric-performance-charts-title' style={{padding:"20px 10px 0px 10px"}}>Overview</p>
                            <Container className='my-4'>
                                <Row className='justify-content-md-left' lg={3} xs={1}>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">Price</Label>
                                        <ReMultiSelect 
                                            className='popup_filter_include_exclude'
                                            closeMenuOnSelect={false}
                                            components={ReMultiSelectAnimated()}
                                            defaultValue={[{ value: 'all', label: 'All' }]}
                                            options={[
                                                { value: 'all', label: 'All' },
                                                { value: '0-50', label: '0-50' },
                                                { value: '50-100', label: '50-100' },
                                                { value: '100-150', label: '100-150' },
                                                { value: '150-200', label: '150-200' },
                                                { value: '200-250', label: '200-250' },
                                                { value: '250-300', label: '250-300' },
                                                { value: '300-350', label: '300-350' },
                                                { value: '350-400', label: '350-400' },
                                            ]}
                                            onChange={(selected_vals) => {
                                                var temp_list = [];
                                                if(selected_vals.value !== "all"){
                                                    temp_list.push([selected_vals.value.split('-')[0], selected_vals.value.split('-')[1]]);
                                                    setPriceRange(temp_list);
                                                }
                                                else{
                                                    setPriceRange(["all"]);
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">Product Type</Label>
                                        <ReMultiSelect 
                                            className='popup_filter_include_exclude'
                                            closeMenuOnSelect={false}
                                            components={ReMultiSelectAnimated()}
                                            isMulti
                                            defaultValue={[]}
                                            options={[
                                                { value: 'Accessories', label: 'Accessories' },
                                                { value: 'Bottom Wear', label: 'Bottom Wear' },
                                                { value: 'Hoodies & Sweat Shirts', label: 'Hoodies & Sweat Shirts' },
                                                { value: 'Shirts', label: 'Shirts' },
                                                { value: 'Suits', label: 'Suits' },
                                                { value: 'Ethnic', label: 'Ethnic' },
                                                { value: 'Upper Wear', label: 'Upper Wear' },
                                            ]}
                                            onChange={(selected_vals) => {
                                                var temp_list = [];
                                                for(var x of selected_vals){
                                                    temp_list.push(x.value);
                                                }
                                                setProductType(temp_list);
                                            }}
                                        />
                                    </Col>
                                    <Col className='p-2 d-flex align-items-end'>
                                        <Button className='d-flex align-items-center justify-content-center' style={{backgroundColor:"white",color:"#00d96d",border:"none",boxShadow:"0 2px 6px rgba(71,86,102,.05)",fontWeight:'500'}} onClick={() => {
                                            setScatterOverviewData(get_scatter_overview_data(overview_data, price_range, selected_product_type))
                                        }}>Apply</Button>
                                    </Col>
                                </Row>
                            </Container>

                            <div className='cro-overview mb-5'>
                                { scatter_overview_data.length > 0 ?
                                    <Chart
                                        chartType="ScatterChart"
                                        width="100%"
                                        height="500px"
                                        data={scatter_overview_data}
                                        options={{
                                            colors: ['#00b6ef'],
                                            pointSize:10,
                                            chartArea: {
                                                width: "85%",
                                                height: "85%"
                                            },
                                            hAxis: { 
                                                title:"Sessions",
                                                ticks:[0,50,100,150,200,250,300,350],
                                                gridlines: {
                                                    color: '#e7e7e7',
                                                },
                                            },
                                            vAxis: {
                                                title:"Add to Cart Ratio",
                                                ticks:[0,25,50,75,100],
                                                gridlines: {
                                                    color: '#e7e7e7',
                                                },
                                            },
                                            curveType: "function",
                                            tooltip: { isHtml: true },
                                            legend: { position:"none" }
                                        }}
                                    />
                                    :
                                    "No data to Show."
                                }
                            </div>

                            <hr />

                            <p className='metric-performance-charts-title' style={{padding:"30px 10px 5px 10px"}}>Product Analysis</p>
                            <Container className='mt-2'>
                                <Row className='justify-content-md-left' lg={2} xs={1}>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">SKU</Label>
                                        <ReMultiSelect 
                                            className='popup_filter_include_exclude'
                                            closeMenuOnSelect={false}
                                            components={ReMultiSelectAnimated()}
                                            defaultValue={[]}
                                            options={[
                                                { value: 'CLUB TENNIS SHORTS', label: 'CLUB TENNIS SHORTS' },
                                                { value: 'Harry Potter: The Houses Men Oversized Hoodies', label: 'Harry Potter: The Houses Men Oversized Hoodies' },
                                                { value: 'AIRPLANE MODE // 006', label: 'AIRPLANE MODE // 006' },
                                                { value: '90’S KID Style Cap', label: '90’S KID Style Cap' },
                                            ]}
                                            onChange={(selected_vals) => {
                                                setAnalyseProductType(selected_vals.value);
                                            }}
                                        />
                                    </Col>
                                    <Col className='p-2 d-flex align-items-end'>
                                        <Button className='d-flex align-items-center justify-content-center' style={{backgroundColor:"white",color:"#00d96d",border:"none",boxShadow:"0 2px 6px rgba(71,86,102,.05)",fontWeight:'500'}} onClick={() => {
                                            var temp_heatmap_data = get_heatmap_data(heatmap_data, sselected_analyse_sku);
                                            document.getElementById("insight").innerHTML = temp_heatmap_data["insights"];
                                            setHeatmapData(temp_heatmap_data);
                                        }}>Analyse</Button>
                                    </Col>
                                </Row>
                            </Container>

                            <Container className='mt-2' style={{backgroundColor:"white", minHeight:"100px"}}>
                                { ((filtered_hetmap_data !== undefined) && (filtered_hetmap_data !== null) && (Object.entries(filtered_hetmap_data).length > 0)) &&
                                    <Row className='justify-content-md-left' style={{padding:"0 !important"}} lg={1} xs={1}>
                                        <Col className='p-2'>
                                            <Chart
                                                chartType="Table"
                                                width={"100%"}
                                                data={filtered_hetmap_data["table_data"]}
                                                options={{
                                                    allowHtml:true,
                                                    width: '100%',
                                                    curveType: "function",
                                                    legend: { position: "bottom" },
                                                    cssClassNames:{
                                                        tableCell :"channel_performance_table_cell",
                                                        headerCell :"channel_performance_header_cell",
                                                        tableRow :"channel_performance_table_row", 
                                                        oddTableRow :"channel_performance_old_table_row" 
                                                    }
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                }
                                </Container>

                                <p className='metric-performance-charts-title' style={{padding:"30px 10px 5px 10px"}}>AI Heatmap Insights</p>
                            <Container className='mt-2' style={{backgroundColor:"white", minHeight:"100px"}}>
                                    <Row className='justify-content-md-left mt-4' lg={2} xs={1}>
                                        <Col className='p-2' style={{width:"700px"}}>
                                            { ((filtered_hetmap_data !== undefined) && (filtered_hetmap_data !== null) && (Object.entries(filtered_hetmap_data).length > 0)) &&
                                                <img src={filtered_hetmap_data["image_url"] === "KID_Style_Cap" ? KID_Style_Cap : (filtered_hetmap_data["image_url"] === "AIRPLANE_MODE_006" ? AIRPLANE_MODE_006 : (filtered_hetmap_data["image_url"] === "Harry_Potter_The_Houses_Men_Oversized_Hoodies"? Harry_Potter_The_Houses_Men_Oversized_Hoodies : Club_Tennis_Short))} alt={filtered_hetmap_data["product_title"]} width={600} height={400}/>
                                            }
                                        </Col>
                                        <Col className='p-2' style={{maxWidth:"400px"}}>
                                            <div id="insight">

                                            </div>
                                        </Col>
                                    </Row>
                            </Container>

                            {/* <div className='main-accordion-body mt-4 p-2' id='product-cro'>
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <b style={{marginLeft:"10px"}}>Understand</b>
                                        </Accordion.Header>
                                        <Accordion.Body style={{padding:"0 !important"}}>
                                            <Container>
                                                <Row sm={2} xs={1}>
                                                    <Col>
                                                        <FunnelChart style={{padding:"5px" ,boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}} width={550} height={460}>
                                                            <Tooltip />
                                                            <Funnel
                                                                dataKey="value"
                                                                data={funnel_data}
                                                                shape={false}
                                                            >
                                                                <LabelList spacing={10} position="center" fill="#000" stroke="none" dataKey="name" />
                                                            </Funnel>
                                                        </FunnelChart>
                                                    </Col>
                                                    <Col>
                                                        <Chart
                                                            style={{boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}}
                                                            chartType="Table"
                                                            width={"100%"}
                                                            data={product_wise_funnel_data}
                                                            options={{
                                                                width: '100%',
                                                                curveType: "function",
                                                                legend: { position: "bottom" },
                                                                // sort: "disable",
                                                                pageSize:6,
                                                                cssClassNames:{
                                                                    tableCell :"cro_table_cell",
                                                                    headerCell :"cro_header_cell",
                                                                    tableRow :"cro_table_row", 
                                                                    oddTableRow :"cro_old_table_row" 
                                                                }
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <b style={{marginLeft:"10px"}}>Analysis</b>
                                        </Accordion.Header>
                                        <Accordion.Body style={{padding:"0 !important"}}>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div> */}
                            
                            </>
                        :
                        <div className='main_conatiner_spinner'>
                            <Spinner animation="border"/>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default ProductCRO


function jsonToArrayObject(res, graph_columns) {
    var columns = Object.keys(res[0]);
    var resultArray = res.map(function (obj) {
      var res_arr = [];
      for (let column_name of columns) {
        res_arr.push(obj[column_name]);
      }
      return res_arr;
    });
    resultArray.unshift(graph_columns)
   return resultArray;
}

function get_heatmap_data(overview_data, product_title){
    var filtered_data = overview_data;
    filtered_data = alasql(`SELECT * FROM ? WHERE product_title = '${product_title}'`, [filtered_data]);
    var final_res = filtered_data[0]
    return final_res;
}

function get_scatter_overview_data(overview_data, price_list, product_type){
    var filtered_data = overview_data;

    if(product_type.length > 0){
        filtered_data = alasql(`SELECT * FROM ? WHERE product_type IN ('${product_type.join("','")}')`, [filtered_data]);
    }

    if(price_list.length > 0){
        for(let price of price_list){
            if( price[0] !== "all"){
                filtered_data = alasql(`SELECT * FROM ? WHERE ((price >= ${price[0]}) AND (price <= ${price[1]}))`, [filtered_data]);
            }
        }
    }

    var res = alasql(`SELECT product_title, sessions, ROUND(((add_to_cart/sessions)*100),1) as add_to_cart  FROM ?`, [filtered_data]);
    var final_res = [["Session","Add to cart ratio", {'role': 'tooltip', 'p': {'html': true}}]]
    for(let obj of res ){
        final_res.push([obj["sessions"],obj["add_to_cart"],`
            <div style="background-color:white; padding:20px; width:fit-content; border-radius:5px; box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)">
                <h6 style="margin:3px;">${obj["product_title"]}</h6>
                <p style="margin:3px; font-size:medium;">Sessions: <b>${obj["sessions"]}</b></p>
                <p style="margin:3px; font-size:medium;">Add to cart ratio: <b>${obj["add_to_cart"]} %</b></p>
            </div>
        `]);
    }

    console.log(res)

    return final_res;
}


const heatmap_data = [
    {
        "product_title":"90’S KID Style Cap", 
        "image_url":"90_KID_Style_Cap", 
        "table_data":[
            ["","Current","Issues","Suggestions"],
            ["Product URL","https://store.digital-mozarts.com/products/90-s-kid-style-cap","-","-"],
            ["Title","90’S KID Style Cap",`&#8226; "90’S" should be "90s" (no apostrophe and lowercase 's').<br><br>&#8226; "KID" should be "Kid" (only the first letter should be capitalized).<br><br>&#8226; "Style Cap" is correct, but consistency in capitalization is important, so you might want to capitalize both words or none, depending on the intended style."`,"&#8226; Variation 1: 90s-Inspired Cap for Kids  <br><br>&#8226; Variation 2: Retro 90s Cap for Kids"],
            ["Description",`Crafted in vintage corduroy, this baseball dad cap is a vibrant time machine that catapults you back to the era of slap bracelets, neon dreams, and cassette tapes. a pixelated portal that celebrates the magic and mischief of growing up in the coolest decade, The 90’s. As you don this dad hat , you'll feel the surge of nostalgia rush over you, transporting you to an era where the height of technology was a Walkman and your social network was your squad of friends on decks.`,`"don this dad hat": This should be "don this dad cap" to maintain consistency with the earlier description.<br><br>&#8226; "a pixelated portal that celebrates the magic and mischief of growing up in the coolest decade, The 90’s": The phrase "The 90’s" should be written as "the 90s" without the apostrophe.`,`&#8226; Variation 1: "This baseball dad cap in vintage corduroy is a lively time capsule, transporting you back to the era of slap bracelets, neon dreams, and cassette tapes. It's like a pixelated gateway that reminisces about the fun and thrill of growing up in the iconic 90s decade. Wear this dad hat and relive the nostalgia of a time when a Walkman was revolutionary and your squad was everything."<br><br>&#8226; Variation 2: "Step back in time with this vintage corduroy baseball dad cap, a vivid journey to the era of slap bracelets, neon dreams, and cassette tapes. It's a nostalgic portal celebrating the magic and mischief of growing up in the 90s, where donning this dad hat evokes memories of Walkmans and close-knit friend groups on decks."`],
            ["No. of Images","4","Too few images","Add another 2-3 product images"],
        ],
        "insights": `
<b>User behaviors</b><br />
1. Desktop users engaged with the product information section but 70% did not scroll past 40%, indicating limited engagement with full page content.<br />
2. A dead click was recorded in the product information section, suggesting possible confusion or unmet expectations at that spot.<br />
3.The first and last clicks for desktop users were on navigation elements like the mode selector button and a primary action button, showing clear entry and exit points.<br /><br />
<b>Key takeaways</b><br />
1. To increase user engagement, DM Ecommerce Store could enhance content visibility below the average fold (697.4px) as most desktop users do not scroll beyond 40% depth.<br />
2. Investigating the cause of dead clicks within the product information section may reveal issues affecting user experience or conversion rates.<br />
3. Emphasizing key navigational elements such as mode selectors or call-to-action buttons can streamline user journeys, as indicated by their use as entry/exit interaction points.<br />
`,
    },
    {
        "product_title":"CLUB TENNIS SHORTS", 
        "image_url":"Club_Tennis_Short", 
        "table_data":[
            ["","Current","Issues","Suggestions"],
            ["Product URL","https://store.digital-mozarts.com/products/club-tennis-shorts","-","-"],
            ["Title","CLUB TENNIS SHORTS",`Title Case Consistency: Using title case can make the title more professional.`,"&#8226; Variation 1: Tennis Club Shorts <br><br>&#8226; Variation 2: Tennis Shorts for Clubs"],
            ["Description",`MOISTURE-WICKING TENNIS SHORTS MADE WITH RECYCLED MATERIALS.Style and performance for the tennis court. These adidas shorts belong to the Club collection. Built with tough ripstop fabric, they'll stand up to all-action play. Meanwhile, AEROREADY will be working in the background, channeling moisture away from your skin to keep you comfortable all the way to game, set and match.Made with 100% recycled materials, this product represents just one of our solutions to help end plastic waste.`,`&#8226; "AEROREADY will be working": Consider revising to "AEROREADY works" for a more direct and active voice."to game, set and match": Consider adding "the" before "game" for grammatical correctness. <br><br>&#8226; Made with 100% recycled materials, this product represents just one of our solutions to help end plastic waste"": This sentence is grammatically correct but could be rephrased for clarity and impact.`,`&#8226; Variation 1: Discover our moisture-wicking tennis shorts, made sustainably with recycled materials. Part of the adidas Club collection, these shorts combine style with high-performance features for the tennis court. Engineered from robust ripstop fabric, they withstand vigorous play. AEROREADY technology regulates moisture, ensuring continuous comfort throughout your game. Crafted exclusively from recycled materials, this product underscores our dedication to environmental sustainability. <br><br>&#8226; Variation 2: Introducing our moisture-wicking tennis shorts, crafted from recycled materials for eco-conscious athletes. These adidas shorts, a part of the Club collection, merge athletic style with top-tier performance on the tennis court. Constructed using durable ripstop fabric, they deliver durability during intense matches. AEROREADY technology manages moisture, guaranteeing comfort from warm-up to match point. With its composition from 100% recycled materials, this product exemplifies our commitment to minimizing plastic waste.`],
            ["No. of Images","4","Too few images","Add another 2-3 product images"],
        ],
        "insights":`
<b>User behaviors</b><br />
1. Desktop users consistently scrolled through 25% of the page, with a significant drop-off after that point.<br />
2. The Open media in modal element received equal attention as both first and last click, indicating interest in product visuals.<br />
3. The Add to cart button was clicked at least once, suggesting some intent to purchase.<br /><br />
<b>Key takeaways</b><br />
1. To maintain user engagement beyond the initial 25%, consider adding compelling content or calls-to-action at strategic scroll depths.<br />
2. Highlighting the Open media in modal feature could enhance visual appeal and encourage further interaction with product images.<br />
3. Optimizing the visibility and attractiveness of the Add to cart button may convert interest into more definitive purchasing actions.<br />
`,
    },
    {
        "product_title":"AIRPLANE MODE // 006", 
        "image_url":"AIRPLANE_MODE_006", 
        "table_data":[
            ["","Current","Issues","Suggestions"],
            ["Product URL","https://store.digital-mozarts.com/products/airplane-mode-006","-","-"],
            ["Title","AIRPLANE MODE // 006",`&#8226; Consistent Casing: Ensure consistency in the casing. If this is a title, "Airplane Mode // 006" might be more conventional with title case.  <br><br>&#8226; Spacing: Ensure proper spacing around the slashes if that is stylistically preferred (though it's not necessary grammatically).`,"&#8226; Variation 1: Aviator Edition // 006  <br><br>&#8226; Variation 2: Airplane Series // 006"],
            ["Description",`You have already loved this pair so much, we had to introduce the Airplane modes in a fresh new tint just in time for spring. Featuring polarized, scratch resistant lenses, these round sunglasses by Urban Monkey are made with nickel free stainless steel making them suitable for all skin types. One to watch out for amongst the blogger and A-list celebrity-set, these sunnies feature straight arms with angled tips, black tinted lenses, a logo on the lens and at the edge of the black acetate tips and adjustable nose pads.`,`&#8226; "Airplane modes": It should be "Airplane mode" (singular) unless referring to multiple distinct modes, but it seems like a specific product name or feature, so it might need clarification. <br><br>&#8226; "sunnies": While commonly used informally, "sunglasses" might be more appropriate depending on the context and audience. <br><br>&#8226; logo on the lens and at the edge of the black acetate tips": Consider adding "s" to "logo" to match the plural noun "tips".`,`&#8226; Variation 1: "Already a beloved choice, we're excited to introduce the Airplane Mode sunglasses in a new tint just in time for spring. These round sunglasses by Urban Monkey are equipped with polarized, scratch-resistant lenses and are crafted from nickel-free stainless steel, ensuring comfort for all skin types. Popular among bloggers and A-list celebrities, these sunnies feature straight arms with angled tips, black-tinted lenses, a logo on the lens and at the edge of the black acetate tips, and adjustable nose pads." <br><br>&#8226; Variation 2: "Introducing the Airplane Mode sunglasses in a fresh new tint for spring, perfect for those who already love this pair. Urban Monkey's round sunglasses feature polarized, scratch-resistant lenses and are made from nickel-free stainless steel, making them suitable for all skin types. Embraced by bloggers and A-list celebrities alike, these sunnies boast straight arms with angled tips, black-tinted lenses, logos on the lens and the edge of the black acetate tips, and adjustable nose pads."`],
            ["No. of Images","4","Too few images","Add another 2-3 product images"],
        ],
        "insights":`
<b>User behaviors</b><br />
1. Desktop users engaged with the page up to 35% scroll depth, indicating they viewed content above this point.<br />
2. All desktop clicks were on the Buy it now button, suggesting a clear intent to purchase.<br />
3. There was no interaction from tablet and mobile users during this period.<br /><br />
<b>Key takeaways</b><br />
1. The website could optimize content placement by ensuring key information is within the top 35% of the page for desktop users.<br />
2. Highlighting or making the Buy it now button more prominent could further improve conversion rates on desktops.<br />
3. Investigating why there's no data from tablet and mobile devices is crucial; technical issues or tracking errors may be present.<br />
`,
    },
    {
        "product_title":"Harry Potter: The Houses Men Oversized Hoodies", 
        "image_url":"Harry_Potter_The_Houses_Men_Oversized_Hoodies",
        "table_data":[
            ["","Current","Issues","Suggestions"],
            ["Product URL","https://store.digital-mozarts.com/products/harry-potter-the-houses-men-oversized-hoodies","-","-"],
            ["Title","Harry Potter: The Houses Men Oversized Hoodies",`&#8226; "The Houses Men": This phrase might be confusing or unclear. It could potentially be "The Houses' Men" if referring to men associated with the houses (like Gryffindor, Slytherin, etc.) in Harry Potter. <br><br>&#8226; "Oversized Hoodies": This is grammatically correct, but consider adding a hyphen for clarity: "Oversized-Hoodies".`,"&#8226; Variation 1: Explore the Harry Potter: The Houses Men Oversized Hoodies <br><br>&#8226; Variation 2: Discover Harry Potter: The Houses Men Oversized Hoodies"],
            ["Description",`Step into Hogwarts with our Harry Potter Houses Men Oversized Hoodies. Crafted from premium cotton blends, each hoodie features the iconic colors and crest of Gryffindor, Slytherin, Hufflepuff, or Ravenclaw. Designed for comfort with an oversized fit, these hoodies are perfect for showcasing your house pride whether lounging at home or out and about. Embrace the magic and style of Harry Potter with these essential wardrobe pieces.`,`&#8226; "Hogwarts with our Harry Potter Houses Men Oversized Hoodies": Consider adding a comma after "Hogwarts" for clarity. <br><br>&#8226; "each hoodie features the iconic colors and crest of Gryffindor, Slytherin, Hufflepuff, or Ravenclaw": Consider adding a comma after "Slytherin" for a clearer list. <br><br>&#8226; "Designed for comfort with an oversized fit, these hoodies are perfect": Consider adding a comma after "fit" for better flow. <br><br>&#8226; "whether lounging at home or out and about": Consider adding a comma after "home" for improved readability.`,`&#8226; Variation 1: Step into Hogwarts with our Harry Potter Houses Men Oversized Hoodies. Crafted from luxurious cotton blends, each hoodie features the distinctive colors and crest of Gryffindor, Slytherin, Hufflepuff, or Ravenclaw. Designed for comfort with an oversized silhouette, these hoodies are perfect for proudly representing your house whether you're unwinding at home or exploring the world. Embrace the enchantment and fashion of Harry Potter with these must-have garments. <br><br>&#8226; Variation 2: Explore Hogwarts with our Harry Potter Houses Men Oversized Hoodies. Constructed from premium cotton blends, each hoodie showcases the iconic colors and crest of Gryffindor, Slytherin, Hufflepuff, or Ravenclaw. Created for comfort with an oversized design, these hoodies are an ideal choice for displaying your house pride whether at home or on the go. Embrace the mystical allure and style of Harry Potter with these essential additions to your wardrobe.`],
            ["No. of Images","4","Too few images","Add another 2-3 product images"],
        ],
        "insights":`
<b>User behaviors</b><br />
1. Desktop users consistently scrolled through 25% of the page, with a significant drop-off after that point.<br />
2. The Buy it now button was the first and last element clicked by desktop users, indicating a clear intent to purchase.<br />
3. One user explored product images in detail as indicated by their click on Open media.<br /><br />
<b>Key takeaways</b><br />
1. To optimize conversion rates, ensure key information and call-to-action buttons like Buy it now are within the top 25% of the page.<br />
2. Given there were no dead or rage clicks, desktop users did not experience noticeable frustration or confusion on this page.<br />
3. Since tablet and mobile data is absent, consider investigating whether technical issues prevented tracking or if visitors primarily use desktops.<br />
`,
    },
];

const overview_data = [
    {
        "product_title":"90’S KID Style Cap", 
        "product_type":"Accessories", 
        "sessions":10, 
        "add_to_cart":3,
        "price":30
    },
    {
        "product_title":"AIRPLANE MODE // 006", 
        "product_type":"Accessories", 
        "sessions":24, 
        "add_to_cart":7,
        "price":20
    },
    {
        "product_title":"CLUB TENNIS SHORTS", 
        "product_type":"Bottom Wear", 
        "sessions":60, 
        "add_to_cart":20,
        "price":65
    },
    {
        "product_title":"CRUISER // 004", 
        "product_type":"Accessories", 
        "sessions":45, 
        "add_to_cart":36,
        "price":20
    },
    {
        "product_title":"DREAMER Cap", 
        "product_type":"Accessories", 
        "sessions":66, 
        "add_to_cart":43,
        "price":30
    },
    {
        "product_title":"DRIP AUTHORITY Cap", 
        "product_type":"Accessories", 
        "sessions":26, 
        "add_to_cart":13,
        "price":30
    },
    {
        "product_title":"Flight MVP Men's Woven Trousers", 
        "product_type":"Bottom Wear", 
        "sessions":77, 
        "add_to_cart":66,
        "price":80
    },
    {
        "product_title":"Harry Potter: The Houses Men Oversized Hoodies", 
        "product_type":"Hoodies & Sweat Shirts", 
        "sessions":89, 
        "add_to_cart":15,
        "price":80
    },
    {
        "product_title":"Iron Man: Armoured Avenger Men Rugby Polo Sweatshirts",
        "product_type":"Hoodies & Sweat Shirts", 
        "sessions":153, 
        "add_to_cart":78,
        "price":70
    },
    {
        "product_title":"MEN BLUE SLIM FIT FORMAL SHIRT", 
        "product_type":"Shirts", 
        "sessions":263, 
        "add_to_cart":140,
        "price":70
    },
    {
        "product_title":"MEN BLUE SOLID SLIM FIT FORMAL TWO PIECE SUIT", 
        "product_type":"Suits", 
        "sessions":120, 
        "add_to_cart":89,
        "price":150
    },
    {
        "product_title":"MEN GREEN SLIM FIT PRINT HALF SLEEVES CASUAL SHIRT", 
        "product_type":"Shirts", 
        "sessions":56, 
        "add_to_cart":48,
        "price":70
    },
    {
        "product_title":"MEN GREEN SLIM FIT STRIPE FULL SLEEVES CASUAL SHIRT", 
        "product_type":"Shirts", 
        "sessions":158, 
        "add_to_cart":99,
        "price":70
    },
    {
        "product_title":"MEN GREEN SOLID SLIM FIT FORMAL THREE PIECE SUIT", 
        "product_type":"Suits", 
        "sessions":147, 
        "add_to_cart":102,
        "price":200
    },
    {
        "product_title":"MEN GREEN SOLID SLIM FIT FORMAL TWO PIECE SUIT", 
        "product_type":"Suits", 
        "sessions":199, 
        "add_to_cart":145,
        "price":150
    },
    {
        "product_title":"MEN GREEN TEXTURED FORMAL KURTA", 
        "product_type":"Ethnic", 
        "sessions":110, 
        "add_to_cart":45,
        "price":50
    },
    {
        "product_title":"MEN KHAKI PRINT CASUAL KURTA", 
        "product_type":"Ethnic", 
        "sessions":83, 
        "add_to_cart":44,
        "price":50
    },
    {
        "product_title":"Men's Woven Trousers", 
        "product_type":"Bottom Wear", 
        "sessions":48, 
        "add_to_cart":40,
        "price":80
    },
    {
        "product_title":"NOCTA Men's Fleece Trousers", 
        "product_type":"Bottom Wear", 
        "sessions":178, 
        "add_to_cart":111,
        "price":70
    },
    {
        "product_title":"Punisher: Vigilante Men Oversized Hoodies", 
        "product_type":"Hoodies & Sweat Shirts", 
        "sessions":246, 
        "add_to_cart":158,
        "price":80
    },
    {
        "product_title":"Superman: Man of Steel Sweatshirts", 
        "product_type":"Hoodies & Sweat Shirts", 
        "sessions":155, 
        "add_to_cart":72,
        "price":70
    },
    {
        "product_title":"Tom and Jerry: Homerun Sweatshirts", 
        "product_type":"Hoodies & Sweat Shirts", 
        "sessions":145, 
        "add_to_cart":79,
        "price":70
    },
    {
        "product_title":"TWINFLAP OLIVE OVERSIZED SHIRT", 
        "product_type":"Upper Wear", 
        "sessions":201, 
        "add_to_cart":119,
        "price":16
    },
    {
        "product_title":"ULTIMATE 2 in 1 SHORTS", 
        "product_type":"Bottom Wear", 
        "sessions":102, 
        "add_to_cart":60,
        "price":40
    },
    {
        "product_title":"UM CLASSIC WAYFARER // 002", 
        "product_type":"Accessories", 
        "sessions":232, 
        "add_to_cart":156,
        "price":20
    },
    {
        "product_title":"Wanderlust Hoodies", 
        "product_type":"Hoodies & Sweat Shirts", 
        "sessions":201, 
        "add_to_cart":89,
        "price":80
    },
    {
        "product_title":"WORKOUT HEAT.RDY PRINT SHORTS", 
        "product_type":"Bottom Wear", 
        "sessions":105, 
        "add_to_cart":96,
        "price":65
    },
    {
        "product_title":"BAD ACID BLACK OVERSIZED T-SHIRT", 
        "product_type":"Upper Wear", 
        "sessions":150, 
        "add_to_cart":99,
        "price":19
    },
    {
        "product_title":"GENIE BLACK DENIM JACKET", 
        "product_type":"Upper Wear", 
        "sessions":269, 
        "add_to_cart":169,
        "price":12
    },
    {"product_title":"BLUE OVERSIZED T-SHIRT", "product_type":"Upper Wear", 
        "sessions":153, 
        "add_to_cart":109,
        "price":15
    },
];